import { apiRequest } from "../index";

export const updateSettings = async (data) => {
  return apiRequest(`/api/common/settings`, "PUT", data , true);
};

export const updatePassword = async (data) => {
  return apiRequest(`/api/common/settings/password-change`, "PUT", data );
};

export const deleteUser = async () => {
  return apiRequest(`/api/common/settings`, "DELETE" );
};

export const getReferralStats = async () => {
  return apiRequest(`/api/common/settings/referral-stats`, "GET");
};


